import React, { useState, useEffect, useCallback } from 'react';
import ErpTemplate from '../../../../components/ErpTemplate';
import {
    FaChevronDown, FaChevronRight, FaFileAlt, FaPen,
    FaDownload, FaSearch, FaCalendarAlt, FaDollarSign, FaUndo,
    FaPaperclip, FaTimes, FaExchangeAlt, FaFileInvoiceDollar
} from 'react-icons/fa';
import api from '../../../../services/api';
import moment from 'moment';
import { moeda } from '../../../../util/util';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import PainelAdiantamentos from '../../../../components/Financeiro/PainelAdiantamentos';
import { DocumentosParcelaModal, TIPOS_DOC_ADIANTAMENTO } from '../../../../components/Financeiro/DocumentosParcela';
import { podeGerenciarDocAdiantamento, AVISO_SEM_PERMISSAO_DOC } from '../../../../components/Financeiro/adiantamentoDocumentoPolicy';
import { OrigemMoeda } from '../../../../components/ValorComOrigem';
import { somarOrigens } from '../../../../components/moedaOrigemPolicy';
import { abaDaUrl, gravarAbasNaUrl } from '../../abasNaUrlPolicy';
import '../../../../css/financeiro-parcela-pagar.css';

export default function PainelParcelaReceber() {
    const token   = localStorage.getItem('token');
    const empresa = localStorage.getItem('empresa');

    // ── Estado ──────────────────────────────────────────────────────────
    const [resumo, setResumo]       = useState({ total_a_receber: 0, em_aberto: 0, recebido: 0, total_nf: 0, total_nd: 0 });
    const [contadores, setContadores] = useState({}); // { pendentes, pagas, adiantamentos } — badges sempre visíveis
    const [eventos, setEventos]     = useState([]);
    const [expandidos, setExpandidos] = useState([]);
    const history = useHistory();
    // D-0097: aba lida da URL e gravada nela (efeito abaixo): o Voltar do Detalhe do adiantamento
    // reabre a aba Adiantamento em vez de cair em A Receber.
    const [abaAtiva, setAbaAtiva]   = useState(() => abaDaUrl(window.location.search, 'aba', ['pendentes', 'pagas', 'adiantamentos'], 'pendentes'));
    const [carregando, setCarregando] = useState(false);
    const [gerandoNd, setGerandoNd] = useState(null); // orcamento_id em andamento

    // Modal de registro de recebimento (NF | ND | Risco Sacado | Estorno)
    const [modalRec, setModalRec]     = useState(null); // { ev, tipo, valor, desagio, observacao, data, arquivo, caixa }
    // Caixas para o "caiu em qual banco" do Registrar Recebimento (obrigatório
    // desde 2026-08-05 — mesma regra do adiantamento: dinheiro tem endereço)
    const [caixasRec, setCaixasRec] = useState([]);
    // Bloqueio SUAVE da trava de dupla contagem: o 422 vem com pode_confirmar e
    // o operador decide assumir o excedente (fica marcado p/ conferência).
    const [modalExcedente, setModalExcedente] = useState(null); // { mensagem, excedente, restante }
    // Devolução de verba emprestada, oferecida logo após o recebimento entrar.
    const [dividasModal, setDividasModal] = useState(null);
    const [quitando, setQuitando] = useState(false);
    const [salvandoRec, setSalvandoRec] = useState(false);
    const [modalExcluir, setModalExcluir] = useState(null); // { rec, eventoId } — confirmação de remoção
    // Recibos do adiantamento: listar + subir mais (Rafael 2026-08-04).
    // O recibo é 1:N via financeiroparcela_arquivo; a tela só não mostrava.
    const [modalRecibos, setModalRecibos] = useState(null); // { parcela }
    const [recebimentosEvt, setRecebimentosEvt] = useState({}); // { [eventoId]: [recebimentos] }

    // Filtros
    const [busca, setBusca]             = useState('');
    const [mesSel, setMesSel]           = useState('');
    const [situacaoEvento, setSituacaoEvento] = useState('');
    const [clienteSel, setClienteSel]   = useState('');

    // Opções dos selects (extraídas dos eventos carregados)
    const [mesesDisponiveis, setMesesDisponiveis]     = useState([]);
    const [clientesDisponiveis, setClientesDisponiveis] = useState([]);

    // ── Busca ────────────────────────────────────────────────────────────
    const buscar = useCallback((manterExpandidos) => {
        // Aba Adiantamentos é autocontida (componente PainelAdiantamentos) — não consome /contasReceber
        if (abaAtiva === 'adiantamentos') return;
        // manterExpandidos=true → refresh "silencioso" (não recolhe o card nem mostra loader)
        if (!manterExpandidos) {
            setCarregando(true);
            setExpandidos([]);
        }

        const params = {
            empresa:          empresa,
            tab:              abaAtiva,
            busca:            busca || undefined,
            mes:              mesSel || undefined,
            situacao_evento:  situacaoEvento || undefined,
        };

        api({
            method: 'get',
            action: '/contasReceber',
            token:  token,
            params: params,
        })
            .then(response => {
                const data = response.data;
                setResumo(data.resumo || {});
                setContadores(data.contadores || {});
                const evs = data.eventos || [];
                setEventos(evs);

                // Monta listas de meses e clientes únicos para os filtros
                const meses    = {};
                const clientes = {};
                evs.forEach(ev => {
                    if (ev.competencia)  meses[ev.competencia]       = true;
                    if (ev.cliente_nome) clientes[ev.cliente_nome]   = true;
                });
                setMesesDisponiveis(Object.keys(meses).sort());
                setClientesDisponiveis(Object.keys(clientes).sort());
            })
            .catch(() => {
                toast.error('Erro ao carregar Contas a Receber.');
            })
            .finally(() => {
                if (!manterExpandidos) setCarregando(false);
            });
    }, [abaAtiva, busca, mesSel, situacaoEvento, empresa, token]);

    // Rebusca quando a aba muda
    useEffect(() => {
        buscar();
    }, [abaAtiva]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        gravarAbasNaUrl(history, { aba: abaAtiva });
    }, [abaAtiva]); // eslint-disable-line react-hooks/exhaustive-deps

    // D-0097: aberta direto em Adiantamento (Voltar do Detalhe, F5), o buscar() não roda e as abas
    // ficariam sem número: busca só os contadores, uma vez.
    useEffect(() => {
        if (abaAtiva !== 'adiantamentos') return;
        api({ method: 'get', action: '/contasReceber', token: token, params: { empresa: empresa, tab: 'pendentes' } })
            .then(function (r) { setContadores((r.data && r.data.contadores) || {}); })
            .catch(function () {});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Caixas do "caiu em qual banco" (uma vez)
    useEffect(() => {
        api({ method: 'get', action: '/financeiroCaixa', token: token, params: {} })
            .then(function (r) { setCaixasRec(r.data.data || []); })
            .catch(function () { setCaixasRec([]); });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Acordeão ─────────────────────────────────────────────────────────
    const toggleExpand = (id) => {
        const expandindo = !expandidos.includes(id);
        setExpandidos(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
        if (expandindo) carregarRecebimentosEvento(id);
    };

    const abrirModalRecibo = (parcela) => setModalRecibos({ parcela });

    const carregarRecebimentosEvento = (eventoId) => {
        api({ method: 'get', action: `/evento/${eventoId}/recebimentos`, token: token })
            .then(function (r) {
                const lista = (r.data && r.data.data) || [];
                setRecebimentosEvt(function (prev) { return { ...prev, [eventoId]: lista }; });
            })
            .catch(function () {});
    };

    const excluirRecebimento = (id, eventoId) => {
        api({ method: 'delete', action: `/eventoRecebimento/${id}`, token: token })
            .then(function (r) {
                var d = r && r.data;
                toast.success((d && d.devolucao_para_custo_previsto)
                    ? 'Recebimento removido. Devolução voltou para Custo Previsto.'
                    : 'Recebimento removido.');
                setModalExcluir(null);
                carregarRecebimentosEvento(eventoId);
                buscar(true);
            })
            .catch(function (err) {
                toast.error((err.response && err.response.data && err.response.data.error) || 'Erro ao remover recebimento.');
            });
    };

    const toggleTodos = () => {
        if (expandidos.length > 0) {
            setExpandidos([]);
        } else {
            setExpandidos(eventosVisiveis.map(ev => ev.evento_id));
        }
    };

    // ── Gerar ND do Evento (download PDF) ────────────────────────────────
    const gerarNd = async (orcamentoId) => {
        if (gerandoNd) return;
        setGerandoNd(orcamentoId);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/orcamento/gerarNdEvento/${orcamentoId}`,
                {
                    method:  'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept:        'application/pdf',
                    },
                }
            );

            if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                toast.error(err.message || 'Nenhum PDF encontrado para este evento.');
                return;
            }

            const blob        = await response.blob();
            const disposition = response.headers.get('content-disposition') || '';
            const match       = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            const nomeArquivo = (match ? match[1] : `ND-Evento-${orcamentoId}.pdf`).replace(/['"]/g, '');

            const url  = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href     = url;
            link.download = nomeArquivo;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            toast.error('Erro ao gerar ND do evento.');
        } finally {
            setGerandoNd(null);
        }
    };

    // ── Recebimentos (NF | ND | Risco Sacado | Estorno) ───────────────────
    // Impostos retidos na NF (de-para: PIS 0,65% / COFINS 3% / CSLL 1% / IRRF 1,5%)
    const IMPOSTOS_NF = [
        { k: 'pis',    l: 'PIS',    aliq: 0.0065 },
        { k: 'cofins', l: 'COFINS', aliq: 0.03 },
        { k: 'csll',   l: 'CSLL',   aliq: 0.01 },
        { k: 'irrf',   l: 'IRRF',   aliq: 0.015 },
    ];
    const parseMoedaBr = (v) => parseFloat(String(v || '').replace(/\./g, '').replace(',', '.')) || 0;
    // Total de impostos retidos (regra dos $10 no IRRF) — líquido = bruto − total
    const calcImpostosNf = (bruto, selecionados) => {
        let total = 0;
        IMPOSTOS_NF.forEach(function (imp) {
            if ((selecionados || []).indexOf(imp.k) === -1) return;
            const ded = bruto * imp.aliq;
            if (imp.k === 'irrf' && ded <= 10) return; // dispensa IRRF ≤ R$10 (Lei 9.430/96)
            total += ded;
        });
        return total;
    };
    const prefillRec = (ev, tipo) => {
        const mapa = {
            nf:           ev.nf_em_aberto,
            nd:           ev.nd_em_aberto,
            risco_sacado: ev.risco_sacado_disponivel,
            estorno:      0,
        };
        const v = mapa[tipo] || 0;
        return v > 0 ? moeda(v) : '';
    };

    const abrirModalRecebimento = (ev, tipo) => {
        const t = tipo || 'nd';
        // Pre-seleciona o documento do tipo escolhido, se houver so um em aberto.
        // Evita que o operador registre no evento quando existe documento — que
        // e justamente o que impede a conciliacao por documento.
        const docs = (ev.documentos || []).filter(function (d) { return d.tipo === t && d.situacao !== 'cancelado'; });
        setModalRec({ ev: ev, tipo: t, documentoId: docs.length === 1 ? docs[0].id : '', valor: prefillRec(ev, t), adiantamento: '', desagio: '', impostoPct: '', abateDe: 'nd', impostos: [], iss: '', pagDuplicado: false, observacao: '', data: moment().format('YYYY-MM-DD'), arquivo: null });
    };

    const trocarTipoRec = (tipo) => {
        if (!modalRec) return;
        const docsT = (modalRec.ev.documentos || []).filter(function (d) { return d.tipo === tipo && d.situacao !== 'cancelado'; });
        setModalRec({ ...modalRec, tipo: tipo, documentoId: docsT.length === 1 ? docsT[0].id : '', valor: prefillRec(modalRec.ev, tipo), adiantamento: '', desagio: '', impostoPct: '', impostos: [], iss: '', pagDuplicado: false });
    };

    // ── Devolução de verba emprestada (reunião do Financeiro, 2026-08-14) ──
    const verificarDividas = (eventoId) => {
        api({ method: 'get', action: '/eventoConta/dividas', token: token, params: { evento_id: eventoId } })
            .then(function (r) {
                var d = r.data || {};
                if (!d.data || d.data.length === 0) return;   // não deve nada: segue a vida
                // Sugere até onde o saldo alcança, na ordem que o backend já
                // devolveu (outros eventos primeiro, Bolsão por último).
                var resta = parseFloat(d.disponivel) || 0;
                var itens = d.data.map(function (x) {
                    var sugerido = Math.min(parseFloat(x.devido) || 0, Math.max(resta, 0));
                    resta = resta - sugerido;
                    return Object.assign({}, x, { marcado: sugerido > 0, valor_quitar: sugerido });
                });
                setDividasModal({ evento_id: eventoId, itens: itens, disponivel: parseFloat(d.disponivel) || 0 });
            })
            .catch(function () { /* silencioso: não atrapalha quem acabou de receber */ });
    };

    const confirmarQuitacao = () => {
        var m = dividasModal;
        if (!m) return;
        var itens = m.itens.filter(function (i) { return i.marcado && (parseFloat(i.valor_quitar) || 0) > 0; })
            .map(function (i) { return { contraparte_evento_id: i.contraparte_evento_id, valor: parseFloat(i.valor_quitar) }; });
        if (itens.length === 0) { setDividasModal(null); return; }
        setQuitando(true);
        api({ method: 'post', action: '/eventoConta/quitar', token: token,
              data: { evento_id: m.evento_id, itens: itens } })
            .then(function () {
                toast.success('Devolução registrada.');
                setDividasModal(null);
                buscar(true);
            })
            .catch(function (e) { toast.error((e.response && e.response.data && e.response.data.mensagem) || 'Erro ao registrar a devolução.'); })
            .finally(function () { setQuitando(false); });
    };

    const salvarRecebimento = () => {
        if (salvandoRec || !modalRec) return;
        const { ev, tipo, valor, adiantamento, desagio, abateDe, impostos, iss, pagDuplicado, observacao, data, arquivo } = modalRec;
        const valorNum = parseFloat(String(valor || '').replace(/\./g, '').replace(',', '.'));
        if (!valorNum || valorNum <= 0) { toast.error('Informe um valor válido.'); return; }

        // Adiantamento abatido não pode passar do bruto (o backend também barra).
        const adiantNum = parseMoedaBr(adiantamento);
        if (adiantNum > valorNum + 0.01) {
            toast.error('O adiantamento abatido (R$ ' + moeda(adiantNum) + ') não pode ser maior que o valor bruto (R$ ' + moeda(valorNum) + ').');
            return;
        }

        // Risco sacado: não pode usar mais que o disponível restante
        if (tipo === 'risco_sacado') {
            const restante = parseFloat(ev.risco_sacado_disponivel) || 0;
            if (valorNum > restante + 0.01) {
                toast.error('Valor excede o risco sacado disponível (R$ ' + moeda(restante) + ').');
                return;
            }
        }

        if (!modalRec.caixa) {
            toast.error(tipo === 'estorno' ? 'Informe de qual banco o valor saiu.' : 'Informe em qual banco o valor caiu.');
            return;
        }

        setSalvandoRec(true);
        const eventoId = ev.evento_id;
        const enviar = (extra, confirmarExcedente) => {
            api({
                method: 'post',
                action: `/evento/${eventoId}/recebimento`,
                token: token,
                data: { tipo: tipo, valor: valor, adiantamento: tipo === 'estorno' ? undefined : (adiantamento || undefined), desagio: tipo === 'risco_sacado' ? desagio : undefined, abate_de: tipo === 'risco_sacado' ? (abateDe || 'nd') : undefined, impostos: tipo === 'nf' ? (impostos || []) : undefined, iss: tipo === 'nf' ? (iss || undefined) : undefined, pagamento_duplicado: tipo === 'nf' ? !!pagDuplicado : undefined, observacao: observacao, data: data, orcamento: ev.orcamento_id || undefined, caixa: modalRec.caixa, evento_documento_id: modalRec.documentoId || undefined, confirmar_excedente: confirmarExcedente ? true : undefined, ...extra },
            })
                .then(function () {
                    toast.success(confirmarExcedente ? 'Recebimento registrado com excedente — o Financeiro foi avisado.' : 'Recebimento registrado.');
                    setModalRec(null); setModalExcedente(null);
                    carregarRecebimentosEvento(eventoId); buscar(true);
                    // Entrou dinheiro: este evento tomou verba emprestada e ainda
                    // não devolveu? (reunião 14/08) NÃO quita sozinho — mostra o
                    // que seria quitado e espera alguém confirmar, porque quitar
                    // mexe no saldo de OUTRO evento.
                    verificarDividas(eventoId);
                })
                .catch(function (err) {
                    var d = (err.response && err.response.data) || {};
                    // Estourou o limite mas dá para assumir: oferece o override
                    if (d.pode_confirmar) {
                        setModalExcedente({
                            mensagem: d.error, excedente: d.excedente, restante: d.restante,
                            // repete a MESMA chamada com o flag — evita remontar o payload
                            retry: function () { enviar(extra, true); },
                        });
                        return;
                    }
                    toast.error(d.error || 'Erro ao registrar recebimento.');
                })
                .finally(function () { setSalvandoRec(false); });
        };

        if (arquivo) {
            const reader = new FileReader();
            reader.onload = function () {
                const uint8 = new Uint8Array(reader.result);
                const hex = Array.from(uint8).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
                enviar({ nomeArquivoRecibo: arquivo.name, binarioArquivoRecibo: hex });
            };
            reader.onerror = function () { setSalvandoRec(false); toast.error('Erro ao ler o recibo.'); };
            reader.readAsArrayBuffer(arquivo);
        } else {
            enviar({});
        }
    };

    // Haver: >0 faltante | <0 pago a mais | 0 quitado
    const haverTone = (h) => (h > 0.001 ? 'is-danger' : (h < -0.001 ? 'is-warn' : 'is-ok'));
    const haverLabel = (h) => (h > 0.001 ? 'Haver (faltante)' : (h < -0.001 ? 'Haver (pago a mais)' : 'Haver (quitado)'));

    // ── Helpers de formatação ─────────────────────────────────────────────
    const formataValor = (val) => moeda(parseFloat(val) || 0);

    const formatarData = (data) => {
        if (!data) return '—';
        const m = moment(data, 'YYYY-MM-DD', true);
        return m.isValid() ? m.format('DD/MM/YYYY') : '—';
    };

    const badgeSituacao = (sit) => {
        if (sit === 'pago')     return 'fin-pp__pill is-ok';
        if (sit === 'vencido')  return 'fin-pp__pill is-danger';
        return 'fin-pp__pill is-warn';
    };

    const labelSituacao = (sit) => {
        if (sit === 'pago')    return 'Pago';
        if (sit === 'vencido') return 'Vencido';
        return 'Em aberto';
    };

    // ── Linha NF ou ND (dentro do acordeão) ──────────────────────────────
    const renderLinhaDoc = (ev, tipo) => {
        const total      = tipo === 'nf' ? ev.nf_total    : ev.nd_total;
        const recebido   = tipo === 'nf' ? ev.nf_recebido : ev.nd_recebido;
        const emAberto   = tipo === 'nf' ? ev.nf_em_aberto : ev.nd_em_aberto;
        const parcelas   = tipo === 'nf' ? (ev.parcelas_nf || []) : (ev.parcelas_nd || []);
        const label      = tipo === 'nf' ? 'NF' : 'ND';
        const badgeTipo  = tipo === 'nf' ? 'fin-pp__minitag is-info' : 'fin-pp__minitag is-warn';
        const colorValor = tipo === 'nf' ? 'text-primary' : 'text-warning';

        if (total <= 0) return null;

        // Situação do grupo NF/ND. Além das parcelas baixadas, o "em aberto" pode
        // ter sido zerado pelo LEDGER (recebimento registrado sem baixar a parcela)
        // — mostrava badge "Em aberto" ao lado de "Em aberto: 0,00" (2026-08-05).
        const todoPago    = parcelas.length > 0 && parcelas.every(function(p) { return p.pago; });
        const quitadoPeloLedger = emAberto <= 0.009 && total > 0;
        const algumVencido = parcelas.some(function(p) { return !p.pago && p.vencida; });
        const sitGrupo    = (todoPago || quitadoPeloLedger) ? 'pago' : algumVencido ? 'vencido' : 'em_aberto';

        // Editar abre o CadastroParcelaReceber, que carrega por TÍTULO (não parcela).
        // Pula parcelas de adiantamento — o título delas não é editável por ali.
        const primeiraEditavel = parcelas.find(function(p) { return !p.eh_adiantamento && p.titulo_id; });
        const primeiraId = primeiraEditavel ? primeiraEditavel.titulo_id : null;

        return (
            <div
                key={tipo}
                className="d-flex align-items-center flex-wrap gap-3 py-2 border-bottom"
                style={{ fontSize: '0.875rem' }}
            >
                {/* Badge tipo */}
                <span className={badgeTipo} style={{ minWidth: 28, textAlign: 'center' }}>{label}</span>

                {/* Situação */}
                <span className={badgeSituacao(sitGrupo)}>{labelSituacao(sitGrupo)}</span>

                {/* Totais */}
                <span>
                    Total:{' '}
                    <strong className={colorValor}>{formataValor(total)}</strong>
                </span>
                <span>
                    Recebido:{' '}
                    <strong className="text-success">{formataValor(recebido)}</strong>
                </span>
                <span>
                    Em aberto:{' '}
                    <strong className="text-danger">{formataValor(emAberto)}</strong>
                </span>

                {/* Editar (não na aba Recebidas) */}
                {primeiraId && abaAtiva !== 'pagas' && (
                    <div className="ms-auto">
                        <Link
                            to={`/cadastroParcelaReceber/${primeiraId}`}
                            className="fin-pp__btn fin-pp__btn--sm"
                            onClick={function(e) { e.stopPropagation(); }}
                        >
                            <FaPen size={12} /> Editar
                        </Link>
                    </div>
                )}

                {/* Detalhe por parcela — a linha acima é só o agregado do grupo.
                    Adiantamento precisa mostrar descrição, onde caiu e os recibos
                    (Rafael 2026-08-04: "preciso dos detalhes deste adiantamento"). */}
                <div style={{ flexBasis: '100%' }}>
                    {parcelas.map(function (p) {
                        const recibos = p.recibos || [];
                        if (!p.eh_adiantamento && recibos.length === 0) return null;
                        return (
                            <div key={'det_' + p.id} style={{ padding: '6px 0 2px 34px', borderTop: '1px dashed #e9ecef' }}>
                                <div className="d-flex align-items-center flex-wrap gap-2" style={{ fontSize: '0.78rem' }}>
                                    {p.eh_adiantamento && <span className="fin-pp__minitag is-ok">Adiantamento</span>}
                                    {p.descricao && <span className="text-muted">{p.descricao}</span>}
                                    {p.caixa_nome && (
                                        <span className="text-muted">· caiu em <strong>{p.caixa_nome}</strong></span>
                                    )}
                                    {p.pagamento && (
                                        <span className="text-muted">· {moment(p.pagamento).format('DD/MM/YYYY')}</span>
                                    )}
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm ms-auto"
                                        style={{ fontSize: '0.72rem' }}
                                        onClick={function (e) { e.stopPropagation(); abrirModalRecibo(p); }}>
                                        <FaPaperclip size={11} /> Recibos ({recibos.length})
                                    </button>
                                </div>
                                {recibos.length > 0 && (
                                    <div className="d-flex flex-wrap gap-2 mt-1">
                                        {recibos.map(function (r) {
                                            return (
                                                <button key={'rec_' + (r.id || r.arquivo_id)} type="button"
                                                    className="fin-pp__minitag is-info"
                                                    style={{ border: 'none', cursor: 'pointer' }}
                                                    title={'Baixar ' + r.nome + (r.created_at ? ' · ' + r.created_at : '')}
                                                    onClick={function (e) {
                                                        e.stopPropagation();
                                                        window.open(process.env.REACT_APP_API_URL + '/arquivo/download/' + r.arquivo_id, '_blank');
                                                    }}>
                                                    📄 {r.nome}
                                                </button>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    // ── Filtro local de cliente ───────────────────────────────────────────
    const eventosVisiveis = clienteSel
        ? eventos.filter(function(ev) { return ev.cliente_nome === clienteSel; })
        : eventos;

    // Resumo recomputado para refletir o filtro local de cliente.
    // Mesmas chaves do resumo global do backend: recebido = baixas + ledger (recebido_total); em aberto = haver.
    const resumoVisiveis = clienteSel ? {
        total_a_receber: eventosVisiveis.reduce(function(s, ev) { return s + (ev.total_bruto         || 0); }, 0),
        em_aberto:       eventosVisiveis.reduce(function(s, ev) { return s + (ev.haver               || 0); }, 0),
        recebido:        eventosVisiveis.reduce(function(s, ev) { return s + (ev.recebido_total      || 0); }, 0),
        total_nf:        eventosVisiveis.reduce(function(s, ev) { return s + (ev.nf_total            || 0); }, 0),
        total_nd:        eventosVisiveis.reduce(function(s, ev) { return s + (ev.nd_total            || 0); }, 0),
    } : resumo;
    // Item 15: fornecedores internacionais dos eventos visíveis (quebra por moeda; total em R$).
    const origemVisiveis = clienteSel
        ? somarOrigens(eventosVisiveis.map(function(ev) { return ev.origem_moeda; }))
        : (resumo && resumo.origem_moeda) || null;

    // ── Render ────────────────────────────────────────────────────────────
    return (
        <ErpTemplate>
            <div className="container-fluid fin-pp" style={{ padding: '18px 24px 48px' }}>

                {/* ── Cabeçalho ──────────────────────────────────────── */}
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Contas a Receber</h1>
                        <p className="fin-pp__subtitle">Por evento · NF e ND com N parcelas cada · Financeiro define o parcelamento</p>
                    </div>
                    <div className="fin-pp__actions">
                        {/* Entrada para a fila do Faturamento — é lá que o evento vira ND/NF
                            antes de chegar aqui como recebível. */}
                        <Link to="/financeiroFaturamento" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm">
                            <FaFileInvoiceDollar size={14} /> Faturamento
                        </Link>
                        <button className="fin-pp__btn fin-pp__btn--sm">
                            <FaDownload size={14} /> Exportar
                        </button>
                    </div>
                </div>

                {/* ── Cards de resumo ────────────────────────────────── */}
                {abaAtiva !== 'adiantamentos' && (
                <section className="fin-pp__kpis" style={{ marginBottom: 16 }}>
                    {[
                        { label: 'Total a Receber', valor: resumoVisiveis.total_a_receber, tone: 'is-info', origem: origemVisiveis },
                        { label: 'Em Aberto',       valor: resumoVisiveis.em_aberto,       tone: 'is-danger' },
                        { label: 'Recebido',        valor: resumoVisiveis.recebido,        tone: 'is-ok'     },
                        { label: 'Total NF',        valor: resumoVisiveis.total_nf,        tone: 'is-info'   },
                        { label: 'Total ND',        valor: resumoVisiveis.total_nd,        tone: 'is-warn'   },
                    ].map(function(card) {
                        return (
                            <div key={card.label} className="fin-pp__kpi">
                                <div className="fin-pp__kpi-top"><span className="fin-pp__kpi-label">{card.label}</span></div>
                                <div className={'fin-pp__kpi-value ' + card.tone}>{formataValor(card.valor)}</div>
                                {card.origem && <OrigemMoeda origem={card.origem} />}
                            </div>
                        );
                    })}
                </section>
                )}

                {/* ── Abas ───────────────────────────────────────────── */}
                <div className="fin-pp__tabs mb-3">
                    {[
                        { key: 'pendentes', label: 'A Receber' },
                        { key: 'pagas', label: 'Recebidas' },
                        { key: 'adiantamentos', label: 'Adiantamento' },
                    ].map(function(t) {
                        var ativa = abaAtiva === t.key;
                        var qtd = contadores[t.key] || 0;
                        return (
                            <button key={t.key} type="button" onClick={function() { setAbaAtiva(t.key); }}
                                className={'fin-pp__tab' + (ativa ? ' is-active' : '')}>
                                {t.label}
                                {qtd > 0 && (
                                    <span className="fin-pp__seg-count">{qtd}</span>
                                )}
                            </button>
                        );
                    })}
                </div>

                {/* Aba Adiantamentos — painel autocontido (entrada de caixa) */}
                {abaAtiva === 'adiantamentos' && <PainelAdiantamentos />}

                {/* ── Filtros + Lista (recebíveis) ───────────────────── */}
                {abaAtiva !== 'adiantamentos' && (
                <>
                {/* ── Filtros ────────────────────────────────────────── */}
                <div className="fin-pp__card" style={{ padding: '14px 16px', marginBottom: 14 }}>
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                        <div className="fin-pp__search-field" style={{ flex: '1 1 240px' }}>
                            <FaSearch className="fin-pp__search-ic" size={16} />
                            <input
                                type="text"
                                className="fin-pp__input"
                                placeholder="Buscar evento ou cliente…"
                                value={busca}
                                onChange={function(e) { setBusca(e.target.value); }}
                                onKeyDown={function(e) { if (e.key === 'Enter') buscar(); }}
                            />
                        </div>
                        <select className="fin-pp__select" value={clienteSel} onChange={function(e) { setClienteSel(e.target.value); }}>
                            <option value="">Todos os clientes</option>
                            {clientesDisponiveis.map(function(c) { return <option key={c} value={c}>{c}</option>; })}
                        </select>
                        <select className="fin-pp__select" value={mesSel} onChange={function(e) { setMesSel(e.target.value); }}>
                            <option value="">Todos os meses</option>
                            {mesesDisponiveis.map(function(m) { return <option key={m} value={m}>{m}</option>; })}
                        </select>
                        {abaAtiva === 'pendentes' && (
                            <select className="fin-pp__select" value={situacaoEvento} onChange={function(e) { setSituacaoEvento(e.target.value); }}>
                                <option value="">Todas as situações</option>
                                <option value="em_aberto">Em aberto</option>
                                <option value="vencido">Vencido</option>
                            </select>
                        )}
                        <button className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall" onClick={buscar} disabled={carregando}>
                            <FaSearch size={14} /> {carregando ? 'Carregando…' : 'Buscar'}
                        </button>
                        <button className="fin-pp__btn fin-pp__btn--tall" onClick={toggleTodos} disabled={eventosVisiveis.length === 0}>
                            {expandidos.length > 0 ? 'Colapsar todos' : 'Expandir todos'}
                        </button>
                    </div>
                </div>

                {/* ── Lista de eventos ───────────────────────────────── */}
                {carregando ? (
                    <div className="fin-pp__empty">Carregando…</div>
                ) : eventosVisiveis.length === 0 ? (
                    <div className="fin-pp__empty">Nenhuma conta encontrada.</div>
                ) : (
                <div className="fin-pp__groups">
                {eventosVisiveis.map(function(ev) {
                    var aberto = expandidos.includes(ev.evento_id);

                    return (
                        <div key={ev.evento_id} className="fin-pp__grp">

                            {/* ── Linha colapsada ──────────────────── */}
                            <div className="fin-pp__grp-head" onClick={function() { toggleExpand(ev.evento_id); }}>
                                <span className="fin-pp__grp-caret">
                                    {aberto ? <FaChevronDown size={11} /> : <FaChevronRight size={11} />}
                                </span>
                                <span className="fin-pp__grp-ic"><FaCalendarAlt size={15} /></span>

                                {/* Identificação do evento */}
                                <div style={{ minWidth: 200, flex: 1 }}>
                                    <div className="fin-pp__grp-name">
                                        {ev.evento_nome}
                                        <span style={{ color: 'var(--fin-ft)', fontWeight: 400, fontSize: 12, marginLeft: 8 }}>· {ev.evento_codigo}</span>
                                    </div>
                                    <div className="fin-pp__client-cnpj" style={{ marginTop: 1 }}>
                                        {ev.cliente_nome}
                                        {ev.cliente_cnpj ? ` · ${ev.cliente_cnpj}` : ''}
                                        {ev.competencia ? ` · Competência ${ev.competencia}` : ''}
                                    </div>
                                </div>

                                {/* Valores resumidos */}
                                <div style={{ display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap' }}>
                                    <div style={{ textAlign: 'right' }}>
                                        <div className="fin-pp__minicard-label">NF</div>
                                        <div className="fin-pp__minicard-value is-info" style={{ fontSize: 13 }}>{formataValor(ev.nf_total)}</div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <div className="fin-pp__minicard-label">ND</div>
                                        <div className="fin-pp__minicard-value is-warn" style={{ fontSize: 13 }}>{formataValor(ev.nd_total)}</div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <div className="fin-pp__minicard-label">Adiantamento</div>
                                        <div className="fin-pp__minicard-value is-ok" style={{ fontSize: 13 }}>{formataValor(ev.total_adiantamento)}</div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <div className="fin-pp__minicard-label">Em aberto</div>
                                        <div className="fin-pp__minicard-value is-danger" style={{ fontSize: 13 }}>{formataValor(ev.em_aberto)}</div>
                                    </div>
                                    {ev.origem_moeda && (
                                        <div style={{ textAlign: 'right' }} title="Fornecedores pagos em moeda estrangeira (valor vigente do Efetivo)">
                                            <div className="fin-pp__minicard-label">Origem internacional</div>
                                            <OrigemMoeda origem={ev.origem_moeda} comBrl />
                                        </div>
                                    )}
                                    <span className={badgeSituacao(ev.situacao)}>
                                        {labelSituacao(ev.situacao)}
                                    </span>
                                </div>
                            </div>

                            {/* ── Corpo expandido ───────────────────── */}
                            {aberto && (
                                <div style={{ padding: '14px 16px', borderTop: '1px solid var(--fin-bd)' }}>

                                    {/* Mini-cards de resumo do evento */}
                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
                                        {[
                                            { label: 'Bruto',             valor: ev.total_bruto,        tone: ''        },
                                            { label: 'NF',                valor: ev.nf_total,           tone: 'is-info' },
                                            { label: 'ND',                valor: ev.nd_total,           tone: 'is-warn' },
                                            { label: 'Fatura (aéreo)',    texto: 'Em construção',       tone: ''        },
                                            { label: 'Adiantamento',      valor: ev.total_adiantamento, tone: 'is-ok'   },
                                            { label: 'Risco Sacado',      valor: ev.risco_sacado_usado, tone: '',
                                              sub: (parseFloat(ev.desagio_total) > 0 ? 'deságio − ' + formataValor(ev.desagio_total) : null) },
                                            { label: 'Imposto',           valor: ev.impostos_total,     tone: 'is-warn' },
                                            { label: 'Líquido a receber', valor: ev.haver,              tone: haverTone(ev.haver) },
                                        ].map(function(mini) {
                                            return (
                                                <div key={mini.label} className="fin-pp__minicard">
                                                    <div className="fin-pp__minicard-label">{mini.label}</div>
                                                    {mini.texto
                                                        ? <div className="fin-pp__minicard-value" style={{ fontSize: 12, color: 'var(--fin-ft)', fontWeight: 600 }}>{mini.texto}</div>
                                                        : <div className={'fin-pp__minicard-value ' + mini.tone}>{formataValor(mini.valor)}</div>}
                                                    {mini.sub && (
                                                        <div style={{ fontSize: '0.66rem', color: 'var(--fin-dg)' }}>{mini.sub}</div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* Fila de conferência: recebimentos confirmados acima do limite */}
                                    {parseFloat(ev.excedente_total) > 0 && (
                                        <div className="d-flex align-items-start gap-2 mb-3 p-2 rounded"
                                            style={{ background: '#fdecea', border: '1px solid #f5c2c0', fontSize: '0.82rem', color: '#8a1f1a' }}>
                                            <span style={{ fontSize: '1.05rem', lineHeight: 1 }}>⚠</span>
                                            <span>
                                                <strong>Conferir: R$ {formataValor(ev.excedente_total)} recebidos acima do total a receber.</strong>{' '}
                                                Um ou mais registros foram confirmados manualmente pelo operador. Verifique se o
                                                valor não entrou duas vezes (baixa de parcela + registro) ou se falta faturar mais
                                                documentos neste evento.
                                            </span>
                                        </div>
                                    )}

                                    {/* Elegíveis ND + botão Gerar ND */}
                                    <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
                                        <small style={{ color: 'var(--fin-mt)' }}>
                                            {ev.nd_pagas_count} parcela(s) ND paga(s)
                                            {ev.nd_pagas_valor > 0 ? ` · ${formataValor(ev.nd_pagas_valor)} elegíveis` : ''}
                                        </small>
                                        <div className="ms-auto d-flex" style={{ gap: 8 }}>
                                            {abaAtiva !== 'pagas' && (
                                                <button
                                                    className="fin-pp__btn fin-pp__btn--sm"
                                                    onClick={function(e) {
                                                        e.stopPropagation();
                                                        abrirModalRecebimento(ev, 'nd');
                                                    }}
                                                >
                                                    + Registrar Recebimento
                                                </button>
                                            )}
                                            {ev.orcamento_id && (
                                                <button
                                                    className="fin-pp__btn fin-pp__btn--sm"
                                                    onClick={function(e) {
                                                        e.stopPropagation();
                                                        gerarNd(ev.orcamento_id);
                                                    }}
                                                    disabled={gerandoNd === ev.orcamento_id}
                                                >
                                                    <FaFileAlt size={13} /> {gerandoNd === ev.orcamento_id ? 'Gerando…' : 'Gerar ND do Evento'}
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {/* Documentos emitidos ao cliente (ND/NF) com o saldo de CADA UM.
                                        Antes existia so o agregado do evento — a Nara nao conseguia
                                        saber de qual documento vinha o valor em aberto para cobrar. */}
                                    {(ev.documentos || []).length > 0 && (
                                        <div className="fin-pp__card" style={{ margin: '0 14px 12px', padding: 0, overflow: 'hidden' }}>
                                            <div className="fin-pp__tblwrap">
                                                <table className="fin-pp__tbl">
                                                    <thead>
                                                        <tr>
                                                            <th>Documento</th>
                                                            <th>Emissão</th>
                                                            <th style={{ textAlign: 'right' }}>Emitido</th>
                                                            <th style={{ textAlign: 'right' }}>Recebido</th>
                                                            <th style={{ textAlign: 'right' }}>Em aberto</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {ev.documentos.map(function (d) {
                                                            var cancelado = d.situacao === 'cancelado';
                                                            var quitado = !cancelado && (parseFloat(d.em_aberto) || 0) < 0.01;
                                                            return (
                                                                <tr key={d.id} style={cancelado ? { opacity: 0.5, textDecoration: 'line-through' } : null}>
                                                                    <td className="fin-pp__cell-strong">{d.rotulo}</td>
                                                                    <td className="fin-pp__cell-muted">
                                                                        {d.data_emissao ? moment(d.data_emissao).format('DD/MM/YYYY') : '—'}
                                                                    </td>
                                                                    <td className="fin-pp__cell-num" style={{ textAlign: 'right' }}>R$ {moeda(d.valor)}</td>
                                                                    <td className="fin-pp__cell-num" style={{ textAlign: 'right' }}>R$ {moeda(d.recebido)}</td>
                                                                    <td className="fin-pp__cell-num" style={{ textAlign: 'right', fontWeight: 600, color: quitado ? 'var(--fin-ok)' : 'var(--fin-dg)' }}>
                                                                        R$ {moeda(d.em_aberto)}
                                                                    </td>
                                                                    <td>
                                                                        {cancelado
                                                                            ? <span className="fin-pp__pill is-muted">Cancelado</span>
                                                                            : quitado
                                                                                ? <span className="fin-pp__pill is-ok">Quitado</span>
                                                                                : d.situacao === 'previsto'
                                                                                    ? <span className="fin-pp__pill is-warn">Previsto</span>
                                                                                    : <span className="fin-pp__pill is-info">Em aberto</span>}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}

                                    {/* Linha NF */}
                                    {renderLinhaDoc(ev, 'nf')}

                                    {/* Linha ND */}
                                    {renderLinhaDoc(ev, 'nd')}

                                    {/* Recebimentos registrados */}
                                    {(recebimentosEvt[ev.evento_id] || []).length > 0 && (
                                        <div style={{ marginTop: 14 }}>
                                            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--fin-mt)', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 6 }}>
                                                Recebimentos registrados
                                            </div>
                                            <div style={{ border: '1px solid var(--fin-bd)', borderRadius: 10, overflow: 'hidden', background: '#fff' }}>
                                                <div style={{ display: 'grid', gridTemplateColumns: '112px 100px 1fr 78px 110px 120px 48px', gap: 8, alignItems: 'center', padding: '8px 12px', background: 'var(--fin-bg, #f6f8fc)', fontSize: 10.5, fontWeight: 700, color: 'var(--fin-mt)', textTransform: 'uppercase', letterSpacing: '.03em' }}>
                                                    <span>Tipo</span>
                                                    <span style={{ textAlign: 'right' }}>Valor</span>
                                                    <span>Detalhe</span>
                                                    <span>Data</span>
                                                    <span>Criado por</span>
                                                    <span>Removido por</span>
                                                    <span></span>
                                                </div>
                                                {(recebimentosEvt[ev.evento_id] || []).map(function(rec) {
                                                    var rotuloTipo = ({ nf: 'NF', nd: 'ND', risco_sacado: 'Risco Sacado', estorno: 'Estorno' })[rec.tipo] || rec.tipo;
                                                    var corTipo = rec.tipo === 'estorno' ? '#dc2626' : (rec.tipo === 'risco_sacado' ? '#a85b07' : (rec.tipo === 'nf' ? '#2563eb' : '#15803d'));
                                                    var desag = parseFloat(rec.desagio) || 0;
                                                    var arq = rec.Arquivo || rec.arquivo_obj;
                                                    var removido = !!rec.removido_em;
                                                    var detalhe = '';
                                                    if (rec.tipo === 'risco_sacado') {
                                                        if (desag > 0) detalhe = 'deságio R$ ' + moeda(desag) + ' · líquido R$ ' + moeda((parseFloat(rec.valor) || 0) - desag);
                                                        if (rec.abate_de) detalhe += (detalhe ? ' · ' : '') + 'abate em ' + String(rec.abate_de).toUpperCase();
                                                    } else if (rec.tipo === 'nf' && rec.valor_liquido != null && (parseFloat(rec.valor_liquido) || 0) !== (parseFloat(rec.valor) || 0)) {
                                                        detalhe = 'impostos R$ ' + moeda((parseFloat(rec.valor) || 0) - (parseFloat(rec.valor_liquido) || 0)) + ' · líquido R$ ' + moeda(parseFloat(rec.valor_liquido) || 0);
                                                    }
                                                    if (rec.observacao) detalhe += (detalhe ? ' · ' : '') + rec.observacao;
                                                    var quem = rec.registrado_por ? rec.registrado_por : '—';
                                                    var quemRem = rec.removido_por_nome ? rec.removido_por_nome : (removido ? '—' : '');
                                                    var riscado = removido ? { textDecoration: 'line-through' } : {};
                                                    return (
                                                        <div key={rec.id} style={{ display: 'grid', gridTemplateColumns: '112px 100px 1fr 78px 110px 120px 48px', gap: 8, alignItems: 'center', padding: '8px 12px', borderTop: '1px solid var(--fin-bd)', fontSize: 12.5, opacity: removido ? 0.55 : 1, background: removido ? '#f8fafc' : 'transparent' }}>
                                                            <span style={{ fontWeight: 700, color: removido ? '#94a3b8' : corTipo, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                                                <span style={{ width: 7, height: 7, borderRadius: '50%', background: removido ? '#cbd5e1' : corTipo, flex: '0 0 auto' }}></span><span style={riscado}>{rotuloTipo}</span>
                                                            </span>
                                                            <span style={Object.assign({ fontFamily: 'monospace', textAlign: 'right' }, riscado)}>{rec.tipo === 'estorno' ? '− ' : ''}R$ {moeda(rec.valor)}</span>
                                                            <span style={Object.assign({ color: 'var(--fin-ft)', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, riscado)} title={detalhe}>{detalhe || '—'}</span>
                                                            <span style={{ color: 'var(--fin-ft)', fontSize: 12 }}>{rec.data ? moment(rec.data).format('DD/MM/YYYY') : ''}</span>
                                                            <span style={{ color: 'var(--fin-mt)', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={quem}>{quem}</span>
                                                            <span style={{ color: 'var(--fin-mt)', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={quemRem + (rec.removido_em ? ' · ' + moment(rec.removido_em).format('DD/MM/YYYY') : '')}>{quemRem}</span>
                                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, justifyContent: 'flex-end' }}>
                                                                {arq && arq.nome && <span title={arq.nome} style={{ color: '#2563eb' }}>📎</span>}
                                                                {!removido && (
                                                                    <button type="button" onClick={function(e) { e.stopPropagation(); setModalExcluir({ rec: rec, eventoId: ev.evento_id }); }}
                                                                        title="Remover" style={{ border: 'none', background: 'transparent', color: '#dc2626', cursor: 'pointer', fontSize: 14, padding: 0, lineHeight: 1 }}>✕</button>
                                                                )}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}

                                    {/* Mensagem quando não há NF nem ND */}
                                    {ev.nf_total <= 0 && ev.nd_total <= 0 && (
                                        <div style={{ color: 'var(--fin-ft)', fontSize: 13, textAlign: 'center', padding: '8px 0' }}>
                                            Nenhuma parcela NF ou ND encontrada para este evento.
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
                </div>
                )}
                </>
                )}
            </div>

            {/* ── Excedente: bloqueio suave com override consciente ── */}
            {modalExcedente && (
                // zIndex acima do modal de Registrar Recebimento (1060, inline):
                // este confirma uma ação DAQUELE modal, então tem de vir por cima.
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" style={{ zIndex: 1080 }}
                    onClick={function(e) { if (e.target === e.currentTarget) setModalExcedente(null); }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-danger">⚠</span>
                                <h3 className="fin-pp__modal-title">
                                    Recebimento acima do total a receber
                                    <span className="fin-pp__modal-sub">
                                        Excedente de R$ {moeda(modalExcedente.excedente || 0)}
                                    </span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={function() { setModalExcedente(null); }}>
                                    <FaTimes size={16} />
                                </button>
                            </div>
                            <div className="modal-body" style={{ fontSize: 13.5, lineHeight: 1.6, color: 'var(--fin-tx)' }}>
                                {modalExcedente.mensagem}
                                <div className="mt-2 p-2 rounded" style={{ background: '#fff8e1', border: '1px solid #ffe082', fontSize: 12.5, color: '#7a5000' }}>
                                    Se o valor caiu mesmo, registre assim: o excedente fica <strong>marcado para
                                    conferência</strong> e o Financeiro é avisado. Fica gravado quem confirmou.
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={function() { setModalExcedente(null); }}>Revisar valor</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--danger" disabled={salvandoRec}
                                    onClick={function() { setSalvandoRec(true); modalExcedente.retry(); }}>
                                    Registrar mesmo assim
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {modalExcluir && (
                <div onClick={function() { setModalExcluir(null); }}
                    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,.45)', zIndex: 1060, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
                    <div onClick={function(e) { e.stopPropagation(); }}
                        style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 440, boxShadow: '0 10px 40px rgba(0,0,0,.2)', overflow: 'hidden' }}>
                        <div style={{ padding: '16px 20px', borderBottom: '1px solid #eef1f6' }}>
                            <div style={{ fontWeight: 700, fontSize: 16, color: '#0f172a' }}>Remover recebimento?</div>
                        </div>
                        <div style={{ padding: '16px 20px', fontSize: 13.5, color: '#475569' }}>
                            <div style={{ marginBottom: 10 }}>
                                Os valores do evento serão <strong>recalculados</strong>. A linha não é apagada — fica marcada como removida (registrando quem removeu).
                            </div>
                            <div style={{ background: '#f6f8fc', border: '1px solid #eef1f6', borderRadius: 8, padding: '8px 12px', fontSize: 12.5 }}>
                                {({ nf: 'NF', nd: 'ND', risco_sacado: 'Risco Sacado', estorno: 'Estorno' })[modalExcluir.rec.tipo] || modalExcluir.rec.tipo}
                                {' · '}R$ {moeda(modalExcluir.rec.valor)}
                                {modalExcluir.rec.data ? ' · ' + moment(modalExcluir.rec.data).format('DD/MM/YYYY') : ''}
                            </div>
                            {modalExcluir.rec.devolucao_parcela_id && (
                                <div style={{ marginTop: 12, fontSize: 12.5, color: '#8a6d00', background: '#fff8e1', border: '1px solid #ffe0a3', borderRadius: 8, padding: '8px 12px' }}>
                                    ⚠️ Este valor gerou uma <strong>devolução em Contas Pendentes</strong> (pode já ter sido paga). Ao remover, a devolução volta para <strong>Custo Previsto</strong> para passar por aprovação. Se já estiver paga, a remoção é bloqueada.
                                </div>
                            )}
                        </div>
                        <div style={{ padding: '12px 20px', borderTop: '1px solid #eef1f6', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={function() { setModalExcluir(null); }}>Cancelar</button>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={function() { excluirRecebimento(modalExcluir.rec.id, modalExcluir.eventoId); }}
                                style={{ background: '#dc2626', color: '#fff', borderColor: '#dc2626' }}>
                                Remover
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {modalRec && (
                <div onClick={function() { if (!salvandoRec) setModalRec(null); }}
                    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,.45)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
                    <div onClick={function(e) { e.stopPropagation(); }}
                        style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 600, boxShadow: '0 10px 40px rgba(0,0,0,.2)', overflow: 'hidden' }}>
                        <div style={{ padding: '16px 20px', borderBottom: '1px solid #eef1f6' }}>
                            <div style={{ fontWeight: 700, fontSize: 16, color: '#0f172a' }}>Registrar Recebimento</div>
                            <div style={{ fontSize: 12.5, color: '#94a3b8', marginTop: 2 }}>{modalRec.ev.evento_nome} · {modalRec.ev.cliente_nome}</div>
                        </div>
                        <div style={{ padding: '16px 20px' }}>
                            <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'nowrap' }}>
                                {[{ k: 'nd', l: 'ND', c: '#15803d' }, { k: 'nf', l: 'NF', c: '#2563eb' }, { k: 'risco_sacado', l: 'Risco Sacado', c: '#a85b07' }, { k: 'estorno', l: 'Estorno', c: '#dc2626' }].map(function(opt) {
                                    var ativo = modalRec.tipo === opt.k;
                                    var Icone = ({ nd: FaFileAlt, nf: FaFileAlt, risco_sacado: FaDollarSign, estorno: FaUndo })[opt.k] || FaFileAlt;
                                    return (
                                        <button key={opt.k} type="button" onClick={function() { trocarTipoRec(opt.k); }}
                                            style={{ flex: '1 1 0', minWidth: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, whiteSpace: 'nowrap', padding: '8px 10px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
                                                border: ativo ? ('1px solid ' + opt.c) : '1px solid #e4e8ef',
                                                background: ativo ? (opt.c + '1f') : '#fff',
                                                color: ativo ? opt.c : '#475569' }}>
                                            <Icone size={12} color={opt.c} style={{ flex: '0 0 auto' }} />
                                            {opt.l}
                                        </button>
                                    );
                                })}
                            </div>

                            <div style={{ background: '#f6f8fc', border: '1px solid #eef1f6', borderRadius: 8, padding: '8px 12px', fontSize: 12.5, color: '#475569', marginBottom: 14, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 6 }}>
                                <span>NF em aberto: <strong>{moeda(modalRec.ev.nf_em_aberto || 0)}</strong></span>
                                <span>ND em aberto: <strong>{moeda(modalRec.ev.nd_em_aberto || 0)}</strong></span>
                                <span>Risco sacado disp.: <strong>{moeda(modalRec.ev.risco_sacado_disponivel || 0)}</strong></span>
                            </div>

                            {/* Documento (ND/NF) que este recebimento abate. So aparece quando o
                                evento tem documento emitido — evento antigo segue sem isto. */}
                            {(function () {
                                const docs = (modalRec.ev.documentos || []).filter(function (d) {
                                    return d.tipo === modalRec.tipo && d.situacao !== 'cancelado';
                                });
                                if (!docs.length || modalRec.tipo === 'estorno' || modalRec.tipo === 'risco_sacado') return null;
                                return (
                                    <div style={{ marginBottom: 14 }}>
                                        <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>
                                            Abater de qual documento?
                                        </label>
                                        <select className="form-control" value={modalRec.documentoId || ''}
                                            onChange={function (e) { setModalRec({ ...modalRec, documentoId: e.target.value }); }}>
                                            <option value="">Sem documento (lança no total do evento)</option>
                                            {docs.map(function (d) {
                                                return (
                                                    <option key={d.id} value={d.id}>
                                                        {d.rotulo} — em aberto {moeda(d.em_aberto)}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                );
                            })()}

                            <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>Valor (R$)</label>
                            <input type="text" className="form-control" value={modalRec.valor}
                                onChange={function(e) {
                                    var nv = e.target.value;
                                    var upd = { ...modalRec, valor: nv };
                                    // Risco sacado: se há Imposto (%), recalcula o deságio sobre o novo valor
                                    if (modalRec.tipo === 'risco_sacado' && modalRec.impostoPct) {
                                        upd.desagio = moeda(parseMoedaBr(nv) * (parseMoedaBr(modalRec.impostoPct) / 100));
                                    }
                                    setModalRec(upd);
                                }}
                                placeholder="0,00" style={{ marginBottom: 12 }} />

                            {/* Adiantamento abatido — composição do Financeiro (Katia):
                                bruto − adiantamento − impostos − deságio = líquido.
                                O adiantamento já entrou antes; informar aqui evita contar 2x na conta do evento. */}
                            {modalRec.tipo !== 'estorno' && (
                                <>
                                    <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>
                                        Adiantamento abatido (R$) <span style={{ fontWeight: 400, color: '#94a3b8' }}>— parte do bruto já recebida antes</span>
                                    </label>
                                    <input type="text" className="form-control" value={modalRec.adiantamento || ''}
                                        onChange={function(e) { setModalRec({ ...modalRec, adiantamento: e.target.value }); }}
                                        placeholder="0,00" style={{ marginBottom: 8 }} />
                                    {parseMoedaBr(modalRec.adiantamento) > 0 && (
                                        <div style={{ fontSize: 11.5, color: parseMoedaBr(modalRec.adiantamento) > parseMoedaBr(modalRec.valor) ? '#c1232b' : '#94a3b8', marginBottom: 12 }}>
                                            {parseMoedaBr(modalRec.adiantamento) > parseMoedaBr(modalRec.valor)
                                                ? '⚠️ O adiantamento não pode ser maior que o valor bruto.'
                                                : 'Não entra em caixa de novo — será lançado como dedução na conta do evento.'}
                                        </div>
                                    )}
                                </>
                            )}

                            {modalRec.tipo === 'nf' && (
                                <>
                                    <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>Selecione os Impostos retidos (sobre o bruto)</label>
                                    <div style={{ display: 'flex', gap: 8, marginBottom: 6, flexWrap: 'nowrap' }}>
                                        {IMPOSTOS_NF.map(function(imp) {
                                            var sel = (modalRec.impostos || []).indexOf(imp.k) !== -1;
                                            return (
                                                <button key={imp.k} type="button"
                                                    onClick={function() {
                                                        var atual = modalRec.impostos || [];
                                                        var novo = sel ? atual.filter(function(x) { return x !== imp.k; }) : atual.concat([imp.k]);
                                                        setModalRec({ ...modalRec, impostos: novo });
                                                    }}
                                                    style={{ flex: '1 1 0', minWidth: 0, whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '7px 8px', borderRadius: 8, fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
                                                        border: sel ? '1px solid #15803d' : '1px solid #e4e8ef',
                                                        background: sel ? 'rgba(21,128,61,0.12)' : '#fff',
                                                        color: sel ? '#15803d' : '#475569' }}>
                                                    {sel && (
                                                        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 16, height: 16, borderRadius: '50%', background: '#15803d', color: '#fff', fontSize: 10, lineHeight: 1 }}>✓</span>
                                                    )}
                                                    {imp.l} {(imp.aliq * 100).toFixed(2).replace('.', ',')}%
                                                </button>
                                            );
                                        })}
                                    </div>
                                    <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>ISS (R$) <span style={{ fontWeight: 400, color: '#94a3b8' }}>— valor manual</span></label>
                                    <input type="text" className="form-control" value={modalRec.iss || ''}
                                        onChange={function(e) { setModalRec({ ...modalRec, iss: e.target.value }); }}
                                        placeholder="0,00" style={{ marginBottom: 8 }} />
                                    <div style={{ fontSize: 11.5, color: '#94a3b8', marginBottom: 12 }}>
                                        Impostos: <strong>R$ {moeda(calcImpostosNf(parseMoedaBr(modalRec.valor), modalRec.impostos) + parseMoedaBr(modalRec.iss))}</strong>
                                        {' · '}Líquido: <strong>R$ {moeda(parseMoedaBr(modalRec.valor) - calcImpostosNf(parseMoedaBr(modalRec.valor), modalRec.impostos) - parseMoedaBr(modalRec.iss))}</strong>
                                    </div>
                                    <div onClick={function() { setModalRec({ ...modalRec, pagDuplicado: !modalRec.pagDuplicado }); }}
                                        style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: 12, padding: '8px 10px', borderRadius: 8,
                                            border: '1px solid ' + (modalRec.pagDuplicado ? '#15803d' : '#e4e8ef'),
                                            background: modalRec.pagDuplicado ? 'rgba(21,128,61,0.10)' : '#fff' }}>
                                        <span style={{ width: 36, height: 20, borderRadius: 999, background: modalRec.pagDuplicado ? '#15803d' : '#cbd5e1', position: 'relative', flex: '0 0 auto' }}>
                                            <span style={{ position: 'absolute', top: 2, left: modalRec.pagDuplicado ? 18 : 2, width: 16, height: 16, borderRadius: '50%', background: '#fff' }}></span>
                                        </span>
                                        <span style={{ fontSize: 12.5, fontWeight: 600, color: modalRec.pagDuplicado ? '#15803d' : '#475569' }}>
                                            Pagamento duplicado
                                            <span style={{ display: 'block', fontWeight: 400, fontSize: 11, color: '#94a3b8' }}>Gera estorno (+7 dias) e devolução em Contas Pendentes</span>
                                        </span>
                                    </div>
                                </>
                            )}

                            {modalRec.tipo === 'risco_sacado' && (
                                <>
                                    <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>Imposto (%) <span style={{ fontWeight: 400, color: '#94a3b8' }}>— calcula o deságio sobre o valor</span></label>
                                    <input type="text" className="form-control" value={modalRec.impostoPct || ''}
                                        onChange={function(e) {
                                            var pct = e.target.value;
                                            setModalRec({ ...modalRec, impostoPct: pct, desagio: moeda(parseMoedaBr(modalRec.valor) * (parseMoedaBr(pct) / 100)) });
                                        }}
                                        placeholder="0,00" style={{ marginBottom: 8 }} />
                                    <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>Deságio / taxa de juros (R$)</label>
                                    <input type="text" className="form-control" value={modalRec.desagio}
                                        onChange={function(e) { setModalRec({ ...modalRec, desagio: e.target.value }); }}
                                        placeholder="0,00" style={{ marginBottom: 4 }} />
                                    <div style={{ fontSize: 11.5, color: '#94a3b8', marginBottom: 12 }}>
                                        Líquido em caixa: <strong>R$ {moeda((parseFloat(String(modalRec.valor || '').replace(/\./g, '').replace(',', '.')) || 0) - (parseFloat(String(modalRec.desagio || '').replace(/\./g, '').replace(',', '.')) || 0))}</strong>
                                    </div>
                                    <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>Abater de</label>
                                    <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                                        {[{ k: 'nd', l: 'ND' }, { k: 'nf', l: 'NF' }].map(function(opt) {
                                            var ativo = (modalRec.abateDe || 'nd') === opt.k;
                                            return (
                                                <button key={opt.k} type="button" onClick={function() { setModalRec({ ...modalRec, abateDe: opt.k }); }}
                                                    style={{ flex: '1 1 auto', padding: '8px 10px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
                                                        border: ativo ? '1px solid #a85b07' : '1px solid #e4e8ef',
                                                        background: ativo ? '#fff8e1' : '#fff',
                                                        color: ativo ? '#a85b07' : '#475569' }}>
                                                    {opt.l}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </>
                            )}

                            <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>
                                {modalRec.tipo === 'estorno' ? 'Saiu de qual banco/caixa? *' : 'Caiu em qual banco/caixa? *'}
                            </label>
                            <select className="form-control" value={modalRec.caixa || ''}
                                onChange={function(e) { setModalRec({ ...modalRec, caixa: e.target.value }); }} style={{ marginBottom: 12 }}>
                                <option value="">— selecione —</option>
                                {caixasRec.map(function(c) {
                                    var ehCartao = parseFloat(c.cartaolimite || 0) > 0;
                                    return <option key={c.id} value={c.id}>{(ehCartao ? '💳 ' : '🏦 ') + c.nome}</option>;
                                })}
                            </select>

                            <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>Data do recebimento</label>
                            <input type="date" className="form-control" value={modalRec.data}
                                onChange={function(e) { setModalRec({ ...modalRec, data: e.target.value }); }} style={{ marginBottom: 12 }} />

                            <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>Recibo (opcional)</label>
                            <input type="file" className="form-control"
                                onChange={function(e) { setModalRec({ ...modalRec, arquivo: (e.target.files && e.target.files[0]) || null }); }} style={{ marginBottom: 12 }} />

                            <label style={{ fontSize: 12.5, fontWeight: 600, color: '#475569' }}>Observação</label>
                            <textarea className="form-control" rows={2} value={modalRec.observacao}
                                onChange={function(e) { setModalRec({ ...modalRec, observacao: e.target.value }); }} />
                        </div>
                        <div style={{ padding: '12px 20px', borderTop: '1px solid #eef1f6', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={function() { setModalRec(null); }} disabled={salvandoRec}>Cancelar</button>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={salvarRecebimento} disabled={salvandoRec}
                                style={{ background: '#2563eb', color: '#fff', borderColor: '#2563eb' }}>
                                {salvandoRec ? 'Salvando…' : 'Registrar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Recibos do adiantamento — D-0118: mesma lista do Detalhe (abrir, substituir e excluir). */}
            {modalRecibos && (
                <DocumentosParcelaModal
                    parcela={modalRecibos.parcela}
                    titulo="Recibos do adiantamento"
                    subtitulo={(modalRecibos.parcela.descricao || 'Adiantamento') + (modalRecibos.parcela.caixa_nome ? ' · ' + modalRecibos.parcela.caixa_nome : '')}
                    tipos={TIPOS_DOC_ADIANTAMENTO.filter(function (t) { return t.key === 'reciboadiantamento'; })}
                    podeGerenciar={podeGerenciarDocAdiantamento(localStorage.getItem('perfil'))}
                    avisoSemPermissao={AVISO_SEM_PERMISSAO_DOC}
                    fechar={function () { setModalRecibos(null); }}
                    onAlterado={function () { buscar(true); }}
                />
            )}

            {dividasModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                     onClick={function (e) { if (e.target === e.currentTarget) setDividasModal(null); }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaExchangeAlt size={17} /></span>
                                <h3 className="fin-pp__modal-title">Este evento tem verba emprestada
                                    <span className="fin-pp__modal-sub">Devolver agora com o dinheiro que acabou de entrar?</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={function () { setDividasModal(null); }}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <div className="fin-pp__tblwrap">
                                    <table className="fin-pp__tbl">
                                        <thead><tr>
                                            <th style={{ width: 40 }}></th>
                                            <th>Devolver para</th>
                                            <th className="text-end">Deve</th>
                                            <th className="text-end" style={{ width: 150 }}>Devolver agora</th>
                                        </tr></thead>
                                        <tbody>
                                            {dividasModal.itens.map(function (i, idx) {
                                                return (
                                                    <tr key={i.contraparte_evento_id}>
                                                        <td>
                                                            <input type="checkbox" checked={!!i.marcado}
                                                                onChange={function (e) {
                                                                    var copia = JSON.parse(JSON.stringify(dividasModal));
                                                                    copia.itens[idx].marcado = e.target.checked;
                                                                    setDividasModal(copia);
                                                                }} />
                                                        </td>
                                                        <td>
                                                            <div className="fin-pp__cell-strong">{i.contraparte_nome}</div>
                                                            {i.eh_bolsao && <span className="fin-pp__minitag is-info">🏦 Bolsão — devolvido por último</span>}
                                                        </td>
                                                        <td className="text-end fin-pp__cell-muted">R$ {moeda(i.devido)}</td>
                                                        <td className="text-end">
                                                            <input className="fin-pp__input text-end" style={{ paddingLeft: 10, height: 34 }}
                                                                inputMode="decimal" value={i.valor_quitar}
                                                                onChange={function (e) {
                                                                    var copia = JSON.parse(JSON.stringify(dividasModal));
                                                                    copia.itens[idx].valor_quitar = e.target.value;
                                                                    setDividasModal(copia);
                                                                }} />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-muted" style={{ fontSize: '0.82rem', marginTop: 10 }}>
                                    Disponível no evento: <strong>R$ {moeda(dividasModal.disponivel)}</strong>.
                                    A ordem já vem sugerida: outros eventos primeiro, Bolsão por último.
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={function () { setDividasModal(null); }}>Agora não</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--primary"
                                    disabled={quitando} onClick={confirmarQuitacao}>
                                    {quitando ? 'Registrando...' : 'Devolver'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </ErpTemplate>
    );
}
